import * as React from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/app'
const root = document.getElementById('root')

createRoot(root).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)
